import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

/* Floating "scroll to top" FAB — appears bottom-right after the user scrolls
   past ~400px. Hidden in embed mode. */
export const ScrollTopFab = ({ lang = "ar", theme = "dark" }) => {
  const dark = theme === "dark";
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={toTop}
      data-testid="scroll-top-fab"
      aria-label={lang === "ar" ? "العودة للأعلى" : "Back to top"}
      className={`fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[60] h-12 w-12 sm:h-14 sm:w-14 rounded-full inline-flex items-center justify-center border transition-all duration-300 ${
        dark
          ? "bg-[#1f2a47]/95 border-[#18c98f]/50 text-[#18c98f] hover:bg-[#18c98f] hover:text-[#182138]"
          : "bg-white/95 border-[#18c98f]/60 text-[#12a777] hover:bg-[#18c98f] hover:text-white"
      } ${show ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"}`}
      style={{
        boxShadow:
          "0 0 0 1px rgba(24,201,143,0.12), 0 10px 30px -8px rgba(24,201,143,0.5), 0 4px 14px -4px rgba(0,0,0,0.4)",
        backdropFilter: "blur(10px)",
      }}
    >
      <ChevronUp className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={3} />
    </button>
  );
};

export default ScrollTopFab;
